import { isRef, toValue, watch } from "vue";
function consoleWatchFn(fn, ...args) {
  const { refOrGetters } = args.reduce(
    (acc, arg) => {
      if (typeof arg === "function" || isRef(arg)) {
        acc.refOrGetters.push(arg);
      } else {
        acc.refOrGetters.push(() => arg);
      }
      return acc;
    },
    { refOrGetters: [] }
  );
  console[fn](...refOrGetters.map(toValue));
  watch(refOrGetters, (newValues) => {
    console[fn](...newValues);
  });
}
const consoleWatch = Object.keys(console).reduce((acc, key) => {
  if (key !== "Console") {
    acc[key] = (...args) => consoleWatchFn(key, ...args);
  }
  return acc;
}, {});
export {
  consoleWatch,
  consoleWatchFn
};
